import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

/**
 * Service for SegmentUsage entity operations.
 * F-017: Saved Selection Segments - Usage tracking access.
 */
@Injectable({
    providedIn: 'root'
})
export class SegmentUsageService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/segmentUsages')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-link';
    }
}
